import { TimeSlotSelectorComponent } from '@agent/core/contact/appointment/time-slot-selection/time-slot-selector.componet';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { BookingMailService, BookingService, InterContactService, QualificationService } from '@contact/upgrade';

import { AppointmentDeprecatedService, default as appointmentDeprecatedServiceName } from './appointment-deprecated.service';
import { AppointmentService } from './appointment.service';
import Appointment from './appointment/appointment.module.ajs';
import { ContactDeprecatedService, default as contactDepreatedServiceName } from './contact-deprecated.service';
import { ContactStatusDeprecatedService, default as contactStatusDeprecatedServiceName } from './contact-status-deprecated.service';
import ContactHistory from './history/contact-history.module';
import { default as interContactDeprecatedServiceName, InterContactDeprecatedService } from './inter-contact-deprecated.service';
import { default as qualificationDeprecatedServiceName, QualificationDeprecatedService } from './qualification-deprecated.service';
import Transfer from './transfer/transfer.module';
import UnitaryTargetSelection from './unitary-target-selection/unitary-target-selection.module';

export default module('contact.agent.core.contact', [Appointment, ContactHistory, Transfer, UnitaryTargetSelection])
  .run([
    contactDepreatedServiceName,
    contactStatusDeprecatedServiceName,
    interContactDeprecatedServiceName,
    qualificationDeprecatedServiceName,
    () => {},
  ])
  // SERVICE
  .service(appointmentDeprecatedServiceName, AppointmentDeprecatedService)
  .service(contactDepreatedServiceName, ContactDeprecatedService)
  .service(contactStatusDeprecatedServiceName, ContactStatusDeprecatedService)
  .service(interContactDeprecatedServiceName, InterContactDeprecatedService)
  .service(qualificationDeprecatedServiceName, QualificationDeprecatedService)
  // DOWNGRADED SERVICE
  .factory('interContactService', downgradeInjectable(InterContactService) as any)
  .factory('qualificationService', downgradeInjectable(QualificationService) as any)
  .factory('contactService', downgradeInjectable(BookingService) as any)
  .factory('bookingMailService', downgradeInjectable(BookingMailService) as any)
  .factory('appointmentService', downgradeInjectable(AppointmentService) as any)
  // DOWNGRADED COMPONENT
  .directive('cngTimeSlotSelector', downgradeComponent({ component: TimeSlotSelectorComponent }) as angular.IDirectiveFactory).name;
